module.exports = __webpack_public_path__ + "img/image-icon.fde978ab.svg";